const TaskTypes = {
    Plates: 'plates',
    EnterTheAnswer: 'enterTheAnswer',
    OnlyDescription: 'onlyDescription',
    Images: 'images',
    QuestionAndAnswers: 'questionAndAnswers',
    Collage: 'collage',
    Milestone: 'milestone',
    Video: 'video',
} as const;

export default TaskTypes;
